import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NeproseService } from '../services/neprose.service';
import { environment } from 'src/environments/environment';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  pages = [
    {value: 1, viewValue: 'Home Page'},
    {value: 2, viewValue: 'About Page'},
    {value: 3, viewValue: 'Contact Page'},
    {value: 4, viewValue: 'Blog Page'}
  ]

  seoData: SeoSocialShareData = {
    title:  'Neprose - About',
    description: 'Nepal Property Services (NEPROSE) is the first internet based marketplace and real estate agency based in Jhapa through which our clients can sell, buy or rent real estates.',
    image: environment.url+'/assets/logo.png'
  };

  backgroundImageURL: any = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/banner.jpg'})`+` no-repeat fixed center`)

  constructor( private _sanitizer: DomSanitizer, private neproseService: NeproseService, private seo: SeoSocialShareService ) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.neproseService.getBannerImage(2).subscribe(data => {
      if(data.status){
        let banner = data.homeBanner
        this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+banner.imagePath})`+` no-repeat fixed center`)
      }
    })
  }

}
